import { Text, TextButton } from '@oneaudi/unified-web-alpha-components';
import { useI18n } from '~/app/i18n/i18n';
import { DialogProps } from '~/app/pages/summary/dialogs/dialog-props';
import { Dialog } from '~/components/dialog';

export default function DisclaimerDialog({ open, onClose }: DialogProps) {
	const { i18n } = useI18n();
	return (
		<Dialog
			open={open}
			onCloseButtonClick={() => {
				onClose();
			}}>
			<>
				<Text tag="p" variant={{ order: '1', style: 'normal' }}>
					{i18n('ngc.stockcar.matches.disclaimer')}
				</Text>
				<TextButton
					onClick={() => {
						onClose();
					}}
					size="md"
					variant="secondary">
					{i18n('ngc.actions.close')}
				</TextButton>
			</>
		</Dialog>
	);
}
